module.exports = __webpack_public_path__ + "img/shiping-banner5.8f4d27ea.png";